(() => {
  // --- Configuration ---
  const animationSpeed = 500; // Base speed for animations like slideToggle

  // --- Utility Functions ---
  const screenUtils = {
    isMobile: () => window.matchMedia("(max-width: 767px)").matches,
    isMobileTablet: () => window.matchMedia("(max-width: 1023px)").matches,
    isTablet: () => window.matchMedia("(min-width: 768px)").matches,
    isDesktop: () => window.matchMedia("(min-width: 1024px)").matches,
    isDesktopXl: () => window.matchMedia("(min-width: 1440px)").matches,
  };

  // --- State Variables ---
  let targetScrollY = window.scrollY; // Target position for wheel scrolling
  let isWheelAnimating = false; // Is the wheel smooth scroll animation running?
  let wheelAnimationId = null; // Stores the requestAnimationFrame ID for wheel scroll
  let isFilterScrolling = false; // Is the filter click scroll animation running?
  let filterAnimationId = null; // Stores the requestAnimationFrame ID for filter scroll
  let isScrollbarActive = false; // Is the user dragging the native scrollbar?

  // --- Smooth Scroll for Mouse Wheel ---
  function smoothScrollWheel() {
    const currentScrollY = window.scrollY;
    const scrollDiff = targetScrollY - currentScrollY;

    // Stop if very close to target or if another scroll took over
    if (Math.abs(scrollDiff) <= 1 || !isWheelAnimating) {
      window.scrollTo(0, targetScrollY); // Ensure final position is exact
      isWheelAnimating = false;
      wheelAnimationId = null;
      return;
    }

    // Simple easing (adjust multiplier for speed/smoothness)
    window.scrollTo(0, currentScrollY + 0.2 * scrollDiff);

    // Continue the loop
    wheelAnimationId = requestAnimationFrame(smoothScrollWheel);
  }

  // --- Scroll Animation for Filter Clicks ---
  function animateScrollToTarget(startY, distance, duration, startTime) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - startTime;
    const progress = Math.min(elapsedTime / duration, 1); // Ensure progress doesn't exceed 1

    // Simple linear easing (could be replaced with easing functions)
    const newY = startY + distance * progress;
    window.scrollTo(0, newY);

    // Continue animation if not complete
    if (progress < 1) {
      filterAnimationId = requestAnimationFrame(() =>
        animateScrollToTarget(startY, distance, duration, startTime)
      );
    } else {
      // Animation finished
      isFilterScrolling = false;
      filterAnimationId = null;
      // Update targetScrollY to the final position to prevent jumps if wheel is used immediately after
      targetScrollY = window.scrollY;
    }
  }

  // --- Function to Initiate Scroll to a Target Element ---
  function scrollToTargetElement(targetElement) {
    // Prevent triggering if already scrolling to a filter target
    if (isFilterScrolling) {
      console.warn("Already scrolling to a filter target.");
      return;
    }

    // --- Stop any ongoing wheel scroll immediately ---
    if (isWheelAnimating && wheelAnimationId) {
      cancelAnimationFrame(wheelAnimationId);
      isWheelAnimating = false;
      wheelAnimationId = null;
    }
    // --- Stop any *previous* filter scroll ( belt-and-suspenders) ---
     if (isFilterScrolling && filterAnimationId) {
       cancelAnimationFrame(filterAnimationId);
       // Keep isFilterScrolling true as we are starting a new one
     }


    isFilterScrolling = true; // Set flag for filter scrolling

    const headerHeight = $("header").height() || 0;
    const targetTop = $(targetElement).offset().top;
    const scrollToPosition = targetTop - headerHeight;

    // Clamp target position to valid scroll range
    const maxScroll = document.body.scrollHeight - window.innerHeight;
    targetScrollY = Math.max(0, Math.min(scrollToPosition, maxScroll)); // Update global target too

    const startY = window.scrollY;
    const distance = targetScrollY - startY;

    // Adjust duration based on distance (optional, for consistency)
    const baseDuration = animationSpeed; // Use a base duration
    // Example: Add 100ms for every 2x header height scrolled
    const dynamicDuration = baseDuration + 100 * Math.floor(Math.abs(distance) / (2 * (headerHeight || 100) )); // Avoid division by zero
    const duration = Math.max(baseDuration, dynamicDuration); // Ensure minimum duration


    const startTime = performance.now();

    // Start the animation
    animateScrollToTarget(startY, distance, duration, startTime);
  }

  // --- Event Listener Setup ---
  $(function () {
    // --- Mouse Down/Up for Scrollbar Detection ---
    document.addEventListener("mousedown", (event) => {
      // Check if click is within approximate scrollbar area
      if (event.clientX >= window.innerWidth - 20) { // 20px buffer for scrollbar
        isScrollbarActive = true;
        // If user grabs scrollbar, stop custom animations
         if (isWheelAnimating && wheelAnimationId) {
             cancelAnimationFrame(wheelAnimationId);
             isWheelAnimating = false;
         }
         if (isFilterScrolling && filterAnimationId) {
             cancelAnimationFrame(filterAnimationId);
             isFilterScrolling = false; // Stop filter scroll intent
         }
      }
    });

    document.addEventListener("mouseup", () => {
      if (isScrollbarActive) {
        isScrollbarActive = false;
        // Update target Y after scrollbar use to prevent jump
        targetScrollY = window.scrollY;
      }
    });

    // --- Wheel Event for Custom Smooth Scroll ---
    window.addEventListener("wheel", (event) => {
        // Ignore wheel event if user is dragging scrollbar or if a filter scroll is active
        if (isScrollbarActive || isFilterScrolling) {
          // Even if filter scrolling, prevent default wheel action to avoid native scroll interference
          event.preventDefault();
          return;
        }

        // Prevent the default browser scroll behavior
        event.preventDefault();

        // --- Stop any ongoing filter scroll if user starts wheeling ---
        // (Optional: Decide if wheel should interrupt filter scroll)
        // if (isFilterScrolling && filterAnimationId) {
        //   cancelAnimationFrame(filterAnimationId);
        //   isFilterScrolling = false;
        // }

        // Calculate scroll delta (cross-browser)
        const delta = event.deltaY || -event.detail || event.wheelDelta;

        // Update the target scroll position (adjust multiplier for scroll speed)
        targetScrollY += 0.7 * delta; // Increased multiplier slightly

        // Clamp the target position to the document boundaries
        targetScrollY = Math.max(0, Math.min(targetScrollY, document.body.scrollHeight - window.innerHeight));

        // Start the smooth scroll animation if it's not already running
        if (!isWheelAnimating) {
          isWheelAnimating = true;
          smoothScrollWheel(); // Start the animation loop
        }
      },
      // Explicitly passive: false because we call preventDefault()
      { passive: false }
    );

    // --- Gifting Section Scroll Effects (Parallax/Sticky) ---
    // (This part remains largely the same as it controls visual effects, not the core scroll mechanism)
    $(".js-gifting-section").each(function () {
      const section = $(this);
      const image = section.find(".js-gifting-section-img"); // Cache image selector

      $(window).on("scroll", function () {
        // Debounce or throttle this handler if performance issues arise
        const scrollTop = $(this).scrollTop();
        const windowHeight = $(window).height();
        const headerHeight = $("header").height() || 0; // Recalculate in case it changes dynamically
        const offset = screenUtils.isMobile() ? headerHeight : 0;
        const scrollBottom = scrollTop + windowHeight;

        const banner = $(".experience-commerce_assets-giftingBanner");
        const filters = $(".js-gifting-banner-filters");
        const content = $(".js-gifting-banner-content");
        const bannerHeight = banner.outerHeight(); // Use outerHeight for accuracy
        const contentHeight = content.offset().top + content.outerHeight(); // Calculate bottom edge of content

        // Sticky banner and filters logic
        const shouldShowFilters = scrollTop > bannerHeight + 70; // Threshold to show filters
        const shouldMakeFiltersSticky = scrollTop > contentHeight; // Filters become sticky after content scrolls past

        // Use boolean flags for clarity before toggling classes
        banner.toggleClass("not-sticky", scrollTop > bannerHeight); // Banner itself might have effects tied to this
        content.toggleClass("z-index-initial", shouldMakeFiltersSticky); // Ensure content goes behind sticky filters
        filters.toggleClass("sticky", shouldMakeFiltersSticky);
        filters.toggleClass("show-filters", shouldShowFilters); // Controls visibility transition

        // Adjust width for sticky filters (only if becoming sticky and width isn't set)
        // Check for 'sticky' class presence for reliability
        if (filters.hasClass('sticky') && $(".js-gifting-banner-filters-inner").css("width") === 'auto') {
          // Use requestAnimationFrame to ensure layout is calculated after class change
           requestAnimationFrame(() => {
             const headerWidth = $(".js-gifting-banner-filters-header").width();
             // Ensure headerWidth is a valid number before setting
             if (headerWidth && headerWidth > 0) {
                $(".js-gifting-banner-filters-inner").css("width", headerWidth);
             }
           });
        }

        // Reset styles and state when scrolling back up above the sticky point
        if (!shouldMakeFiltersSticky) {
          $(".js-gifting-banner-filters-list-wrapper").removeAttr("style"); // Clear potential inline styles from slideToggle
          $(".js-gifting-banner-filters-inner").removeAttr("style"); // Clear width override
          filters.removeClass("open"); // Ensure dropdown is closed
        }

        // --- Section Image Scaling and Translation ---
        if (image.length) { // Only proceed if image exists
            const sectionTop = section.offset().top;
            const sectionHeight = section.outerHeight();
            const nextSection = section.next(".js-gifting-products-list");
            const nextSectionTop = nextSection.length ? nextSection.offset().top : document.body.scrollHeight; // Fallback if no next section

            const sectionStartThreshold = sectionTop - windowHeight; // When section bottom enters view
            const sectionEndThreshold = sectionTop + sectionHeight;   // When section top leaves view

             // Calculate translation based on how much of the section is scrolled past its top
            const scrollPastSectionTop = scrollTop - (sectionTop - headerHeight);
            const translateY = scrollPastSectionTop * (screenUtils.isMobile() ? 0.1 : 0.3); // Adjust multiplier for effect intensity

            // Calculate scale based on scroll position relative to the section
            let scale = 1.0;
            const viewPortProgress = (scrollBottom - sectionTop) / windowHeight; // How far through the viewport the section top is

             if (screenUtils.isMobile()) {
                 // Mobile: Scale slightly based on scroll position between section top and next section top
                 const scrollRangeMobile = nextSectionTop - sectionTop;
                 // Ensure scrollRangeMobile is not zero to avoid division by zero
                 const mobileProgress = scrollRangeMobile > 0 ? Math.min(Math.max((scrollTop + headerHeight - sectionTop) / scrollRangeMobile, 0), 1) : 0;
                 scale = 1 + 0.05 * mobileProgress; // Scale up slightly as user scrolls down *within* the section

             } else {
                 // Desktop: Different scale logic (original logic adapted)
                 // Scale down slightly as section enters view
                 const entryScaleFactor = 1.1 - 0.1 * Math.min(Math.max(viewPortProgress, 0), 1);
                 // Scale up slightly as section leaves view (towards next section)
                 const exitScaleProgress = Math.min(Math.max((scrollTop - sectionEndThreshold) / windowHeight, 0), 1); // How far past the end of the section
                 const exitScaleFactor = 1 + 0.1 * exitScaleProgress;

                 // Determine dominant scale based on scroll position
                 if (scrollTop < sectionTop) { // Approaching section
                     scale = entryScaleFactor;
                 } else if (scrollTop < sectionEndThreshold) { // Within section
                     // Could blend entry/exit or use a fixed scale like 1.1
                      scale = 1.1; // Or keep entryScaleFactor
                 }
                 else { // Past section
                      scale = exitScaleFactor;
                 }
             }

            // Apply the transform
            image.css({ transform: `scale(${scale}) translateY(${translateY}px)` });
        }

      }); // End scroll handler for section
    }); // End .each gifting section

    // --- Filter Link Click Event ---
    $(".js-gifting-banner-filters-link").on("click", function (event) {
      event.preventDefault(); // Prevent default anchor link behavior

      const targetLink = $(this);
      const filtersContainer = $(".js-gifting-banner-filters");
      const isSticky = filtersContainer.hasClass("sticky");
      const targetSectionId = targetLink.attr("href");
      const targetSectionElement = $(targetSectionId);

      // Update selected filter text
      $(".js-gifting-banner-filters-selected").text(targetLink.text());

      // --- Handle Dropdown Animation ---
      const filterListWrapper = $(".js-gifting-banner-filters-list-wrapper");
      let widthAnimationPromise = $.Deferred().resolve().promise(); // A resolved promise for timing

      if (isSticky) {
        // Only toggle if it's currently open (clicking a link should close it)
        if (filtersContainer.hasClass("open")) {
          filterListWrapper.slideUp(animationSpeed); // Use slideUp for consistency
        }
      }

      // --- Handle Width Animation (if sticky and not mobile) ---
      if (isSticky && !screenUtils.isMobile()) {
          const filtersInner = $(".js-gifting-banner-filters-inner");
          const titleWidth = $(".js-gifting-banner-filters-title").outerWidth(true); // Include margins
          const selectedWidth = $(".js-gifting-banner-filters-selected").outerWidth(true);
          const arrowWidth = $(".js-gifting-banner-filters-arrow").outerWidth(true);
          const newWidth = titleWidth + selectedWidth + arrowWidth; // Calculate target width

          // Create a promise for the width animation
          widthAnimationPromise = filtersInner.animate({ width: newWidth }, animationSpeed).promise();
      } else if (screenUtils.isMobile()) {
          // On mobile, adjust width immediately if needed (original logic)
          const filtersInner = $(".js-gifting-banner-filters-inner");
          const titleWidth = $(".js-gifting-banner-filters-title").outerWidth(true);
          const statusWidth = $(".js-gifting-banner-filters-status").outerWidth(true);
          filtersInner.css("width", titleWidth + statusWidth);
      }


      // --- Scroll to Target Section ---
      // Wait for animations (slide, width) to roughly finish before starting scroll
      $.when(widthAnimationPromise).done(() => {
        filtersContainer.removeClass("open"); // Ensure closed state after animations

        if (targetSectionElement.length) {
          scrollToTargetElement(targetSectionElement); // Use the improved scroll function
        } else {
          console.warn(`Target section "${targetSectionId}" not found.`);
        }
      });

    }); // End filter link click handler

    // --- Filter Header Click Event (for toggling dropdown) ---
    $(".js-gifting-banner-filters-header").on("click", function () {
        const filtersContainer = $(".js-gifting-banner-filters");
        const filterListWrapper = $(".js-gifting-banner-filters-list-wrapper");
        const isSticky = filtersContainer.hasClass("sticky"); // Check if sticky when clicked
        const isOpen = filtersContainer.hasClass("open");

        // Toggle the dropdown visibility
        filterListWrapper.slideToggle(animationSpeed);

        // Animate width only if sticky and not on mobile
        if (isSticky && !screenUtils.isMobile()) {
            const filtersInner = $(".js-gifting-banner-filters-inner");
            const titleWidth = $(".js-gifting-banner-filters-title").outerWidth(true);
            const selectedWidth = $(".js-gifting-banner-filters-selected").outerWidth(true);
            const arrowWidth = $(".js-gifting-banner-filters-arrow").outerWidth(true);
            const statusWidth = $(".js-gifting-banner-filters-status").outerWidth(true); // Needed for closed state width

            // Target width depends on whether we are opening or closing
            // Use the *future* state after toggleClass runs
            const targetWidth = !isOpen
                ? titleWidth + selectedWidth + arrowWidth // Target width when opening
                : titleWidth + statusWidth; // Target width when closing

            filtersInner.animate({ width: targetWidth }, animationSpeed);
        }

        // Toggle the open class *after* starting animations
        filtersContainer.toggleClass("open");
    }); // End filter header click handler


    // --- Initial Setup on Window Load ---
    $(window).on("load", function () {
      // Set initial filter text based on the first link
      const firstFilterText = $(".js-gifting-banner-filters-link:first").text();
      if (firstFilterText) {
         $(".js-gifting-banner-filters-selected").text(firstFilterText);
      }

      // Trigger initial scroll calculations/effects
      $(window).trigger("scroll"); // Use trigger instead of direct call

      // Fade in content after a delay (visual flourish)
      setTimeout(() => {
        $(".js-gifting-banner-content").addClass("show");
      }, 300);

      // Set initial target scroll Y
      targetScrollY = window.scrollY;
    });

  }); // End jQuery DOM ready
})(); // End IIFE

function e(n, i) {
  n.length > i && (0 == i ? ($(n.get(i)).addClass("show"),
  e(n, 1)) : window.matchMedia("(max-width: 767px)").matches ? ($(n.get(i)).addClass("show"),
  i += 1,
  t && e(n, i)) : setTimeout((function() {
      $(n.get(i)).addClass("show"),
      i += 1,
      t && e(n, i)
  }
  ), 200))
}
$('.product-tile:not(".disable-animation")').on("mouseenter focusin", (function(n) {
  t = !0;
  var i = $(this).find(".mfk-productTile-olfactive").removeClass("show");
  i.length > 0 && (e(i, 0),
  $(this).addClass("is-hover"))
}
)),
$('.product-tile:not(".disable-animation")').on("mouseleave focusout", (function() {
  t = !1,
  $(this).find(".mfk-productTile-olfactive").removeClass("show"),
  $(this).removeClass("is-hover")
}
))